export default {
    "address": "0x0860Bb2C1739edcFfBB735dCABD282F9C651D8B1",
    "abi": [{
        "inputs": [{"internalType": "address", "name": "initialOwner", "type": "address"}],
        "stateMutability": "nonpayable",
        "type": "constructor"
    }, {"inputs": [], "name": "AlreadyUnlocked", "type": "error"}, {
        "inputs": [],
        "name": "AmountCannotBeZero",
        "type": "error"
    }, {
        "inputs": [{"internalType": "address", "name": "currency0", "type": "address"}, {
            "internalType": "address",
            "name": "currency1",
            "type": "address"
        }], "name": "CurrenciesOutOfOrderOrEqual", "type": "error"
    }, {"inputs": [], "name": "CurrencyNotSettled", "type": "error"}, {
        "inputs": [],
        "name": "DelegateCallNotAllowed",
        "type": "error"
    }, {"inputs": [], "name": "ERC20TransferFailed", "type": "error"}, {
        "inputs": [],
        "name": "InvalidCaller",
        "type": "error"
    }, {"inputs": [], "name": "InvalidRecipient", "type": "error"}, {
        "inputs": [],
        "name": "InvalidReserves",
        "type": "error"
    }, {"inputs": [], "name": "LiquidityLocked", "type": "error"}, {
        "inputs": [],
        "name": "MustClearExactPositiveDelta",
        "type": "error"
    }, {"inputs": [], "name": "NativeTransferFailed", "type": "error"}, {
        "inputs": [],
        "name": "NonzeroNativeValue",
        "type": "error"
    }, {"inputs": [], "name": "NotEnoughReserves", "type": "error"}, {
        "inputs": [{
            "internalType": "PoolId",
            "name": "id",
            "type": "bytes32"
        }], "name": "PoolAlreadyInitialized", "type": "error"
    }, {"inputs": [], "name": "PoolNotInitialized", "type": "error"}, {
        "inputs": [],
        "name": "ProtocolFeeCurrencySynced",
        "type": "error"
    }, {
        "inputs": [{"internalType": "uint24", "name": "fee", "type": "uint24"}],
        "name": "ProtocolFeeTooLarge",
        "type": "error"
    }, {"inputs": [], "name": "SafeCastOverflow", "type": "error"}, {
        "inputs": [],
        "name": "Unauthorized",
        "type": "error"
    }, {"inputs": [], "name": "VaultLocked", "type": "error"}, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "spender",
            "type": "address"
        }, {"indexed": true, "internalType": "uint256", "name": "id", "type": "uint256"}, {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
        }],
        "name": "Approval",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": false, "internalType": "uint8", "name": "feeType", "type": "uint8"}, {
            "indexed": false,
            "internalType": "uint8",
            "name": "newFee",
            "type": "uint8"
        }],
        "name": "DefaultProtocolFeeUpdated",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "id", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "Currency",
            "name": "currency",
            "type": "address"
        }, {"indexed": true, "internalType": "address", "name": "sender", "type": "address"}, {
            "indexed": false,
            "internalType": "uint8",
            "name": "feeType",
            "type": "uint8"
        }, {"indexed": false, "internalType": "uint256", "name": "feeAmount", "type": "uint256"}],
        "name": "Fees",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "id", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "Currency",
            "name": "currency0",
            "type": "address"
        }, {"indexed": true, "internalType": "Currency", "name": "currency1", "type": "address"}, {
            "indexed": false,
            "internalType": "uint24",
            "name": "fee",
            "type": "uint24"
        }, {"indexed": false, "internalType": "uint24", "name": "marginFee", "type": "uint24"}],
        "name": "Initialize",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "id", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "bool", "name": "lendingForOne", "type": "bool"}, {
            "indexed": false,
            "internalType": "int128",
            "name": "lendingAmount",
            "type": "int128"
        }, {
            "indexed": false,
            "internalType": "uint256",
            "name": "depositCumulativeLast",
            "type": "uint256"
        }, {"indexed": false, "internalType": "bytes32", "name": "salt", "type": "bytes32"}],
        "name": "Lend",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "marginController", "type": "address"}],
        "name": "MarginControllerUpdated",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "MarginState", "name": "newMarginState", "type": "bytes32"}],
        "name": "MarginStateUpdated",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "id", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "int256", "name": "callerDelta", "type": "int256"}, {
            "indexed": false,
            "internalType": "int256",
            "name": "liquidityDelta",
            "type": "int256"
        }, {"indexed": false, "internalType": "bytes32", "name": "salt", "type": "bytes32"}],
        "name": "ModifyLiquidity",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "operator",
            "type": "address"
        }, {"indexed": false, "internalType": "bool", "name": "approved", "type": "bool"}],
        "name": "OperatorSet",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "user", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
        }],
        "name": "OwnershipTransferred",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "protocolFeeController", "type": "address"}],
        "name": "ProtocolFeeControllerUpdated",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "id", "type": "bytes32"}, {
            "indexed": false,
            "internalType": "uint24",
            "name": "protocolFee",
            "type": "uint24"
        }],
        "name": "ProtocolFeeUpdated",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "PoolId", "name": "id", "type": "bytes32"}, {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
        }, {"indexed": false, "internalType": "int128", "name": "amount0", "type": "int128"}, {
            "indexed": false,
            "internalType": "int128",
            "name": "amount1",
            "type": "int128"
        }, {"indexed": false, "internalType": "uint24", "name": "fee", "type": "uint24"}],
        "name": "Swap",
        "type": "event"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": false, "internalType": "address", "name": "caller", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "from",
            "type": "address"
        }, {"indexed": true, "internalType": "address", "name": "to", "type": "address"}, {
            "indexed": true,
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
        }, {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}],
        "name": "Transfer",
        "type": "event"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}, {
            "internalType": "address",
            "name": "spender",
            "type": "address"
        }, {"internalType": "uint256", "name": "id", "type": "uint256"}],
        "name": "allowance",
        "outputs": [{"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "spender", "type": "address"}, {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "name": "approve",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}, {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
        }],
        "name": "balanceOf",
        "outputs": [{"internalType": "uint256", "name": "balance", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "name": "burn",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "Currency", "name": "currency", "type": "address"}, {
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
        }], "name": "clear", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "recipient", "type": "address"}, {
            "internalType": "Currency",
            "name": "currency",
            "type": "address"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "name": "collectProtocolFees",
        "outputs": [{"internalType": "uint256", "name": "amountCollected", "type": "uint256"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "defaultProtocolFee",
        "outputs": [{"internalType": "uint24", "name": "", "type": "uint24"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes32", "name": "slot", "type": "bytes32"}],
        "name": "extsload",
        "outputs": [{"internalType": "bytes32", "name": "", "type": "bytes32"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes32", "name": "startSlot", "type": "bytes32"}, {
            "internalType": "uint256",
            "name": "nSlots",
            "type": "uint256"
        }],
        "name": "extsload",
        "outputs": [{"internalType": "bytes32[]", "name": "", "type": "bytes32[]"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes32[]", "name": "slots", "type": "bytes32[]"}],
        "name": "extsload",
        "outputs": [{"internalType": "bytes32[]", "name": "", "type": "bytes32[]"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes32[]", "name": "slots", "type": "bytes32[]"}],
        "name": "exttload",
        "outputs": [{"internalType": "bytes32[]", "name": "", "type": "bytes32[]"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes32", "name": "slot", "type": "bytes32"}],
        "name": "exttload",
        "outputs": [{"internalType": "bytes32", "name": "", "type": "bytes32"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }], "name": "initialize", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "owner", "type": "address"}, {
            "internalType": "address",
            "name": "operator",
            "type": "address"
        }],
        "name": "isOperator",
        "outputs": [{"internalType": "bool", "name": "isOperator", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }, {
            "components": [{"internalType": "bool", "name": "lendForOne", "type": "bool"}, {
                "internalType": "int128",
                "name": "lendAmount",
                "type": "int128"
            }, {"internalType": "bytes32", "name": "salt", "type": "bytes32"}],
            "internalType": "struct IVault.LendParams",
            "name": "params",
            "type": "tuple"
        }],
        "name": "lend",
        "outputs": [{"internalType": "BalanceDelta", "name": "lendDelta", "type": "int256"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }, {
            "components": [{
                "internalType": "enum MarginActions",
                "name": "action",
                "type": "uint8"
            }, {"internalType": "bool", "name": "marginForOne", "type": "bool"}, {
                "internalType": "uint128",
                "name": "marginTotal",
                "type": "uint128"
            }, {"internalType": "uint256", "name": "marginFeeAmount", "type": "uint256"}, {
                "internalType": "uint256",
                "name": "swapFeeAmount",
                "type": "uint256"
            }, {
                "internalType": "BalanceDelta",
                "name": "marginDelta",
                "type": "int256"
            }, {
                "internalType": "BalanceDelta",
                "name": "mirrorDelta",
                "type": "int256"
            }, {"internalType": "BalanceDelta", "name": "pairDelta", "type": "int256"}, {
                "internalType": "BalanceDelta",
                "name": "lendDelta",
                "type": "int256"
            }, {"internalType": "uint256", "name": "debtDepositCumulativeLast", "type": "uint256"}],
            "internalType": "struct MarginBalanceDelta",
            "name": "params",
            "type": "tuple"
        }],
        "name": "marginBalance",
        "outputs": [{"internalType": "BalanceDelta", "name": "marginDelta", "type": "int256"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "marginController",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "marginState",
        "outputs": [{"internalType": "MarginState", "name": "", "type": "bytes32"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "to", "type": "address"}, {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "name": "mint",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }, {
            "components": [{
                "internalType": "uint256",
                "name": "amount0",
                "type": "uint256"
            }, {"internalType": "uint256", "name": "amount1", "type": "uint256"}, {
                "internalType": "int256",
                "name": "liquidityDelta",
                "type": "int256"
            }, {"internalType": "bytes32", "name": "salt", "type": "bytes32"}],
            "internalType": "struct IVault.ModifyLiquidityParams",
            "name": "params",
            "type": "tuple"
        }],
        "name": "modifyLiquidity",
        "outputs": [{
            "internalType": "BalanceDelta",
            "name": "callerDelta",
            "type": "int256"
        }, {"internalType": "int128", "name": "finalLiquidityDelta", "type": "int128"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "owner",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "protocolFeeController",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "Currency", "name": "currency", "type": "address"}],
        "name": "protocolFeesAccrued",
        "outputs": [{"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "enum FeeTypes", "name": "feeType", "type": "uint8"}, {
            "internalType": "uint8",
            "name": "newFee",
            "type": "uint8"
        }], "name": "setDefaultProtocolFee", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "controller", "type": "address"}],
        "name": "setMarginController",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "MarginState", "name": "newMarginState", "type": "bytes32"}],
        "name": "setMarginState",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "operator", "type": "address"}, {
            "internalType": "bool",
            "name": "approved",
            "type": "bool"
        }],
        "name": "setOperator",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }, {"internalType": "enum FeeTypes", "name": "feeType", "type": "uint8"}, {
            "internalType": "uint8",
            "name": "newFee",
            "type": "uint8"
        }], "name": "setProtocolFee", "outputs": [], "stateMutability": "nonpayable", "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "controller", "type": "address"}],
        "name": "setProtocolFeeController",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "settle",
        "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "recipient", "type": "address"}],
        "name": "settleFor",
        "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
        "stateMutability": "payable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes4", "name": "interfaceId", "type": "bytes4"}],
        "name": "supportsInterface",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{
            "components": [{
                "internalType": "Currency",
                "name": "currency0",
                "type": "address"
            }, {"internalType": "Currency", "name": "currency1", "type": "address"}, {
                "internalType": "uint24",
                "name": "fee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}],
            "internalType": "struct PoolKey",
            "name": "key",
            "type": "tuple"
        }, {
            "components": [{"internalType": "bool", "name": "zeroForOne", "type": "bool"}, {
                "internalType": "int256",
                "name": "amountSpecified",
                "type": "int256"
            }, {"internalType": "bool", "name": "useMirror", "type": "bool"}, {
                "internalType": "bytes32",
                "name": "salt",
                "type": "bytes32"
            }], "internalType": "struct IVault.SwapParams", "name": "params", "type": "tuple"
        }],
        "name": "swap",
        "outputs": [{"internalType": "BalanceDelta", "name": "swapDelta", "type": "int256"}, {
            "internalType": "uint24",
            "name": "swapFee",
            "type": "uint24"
        }, {"internalType": "uint256", "name": "feeAmount", "type": "uint256"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "Currency", "name": "currency", "type": "address"}],
        "name": "sync",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "Currency", "name": "currency", "type": "address"}, {
            "internalType": "address",
            "name": "to",
            "type": "address"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "name": "take",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "receiver", "type": "address"}, {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
        }, {"internalType": "uint256", "name": "amount", "type": "uint256"}],
        "name": "transfer",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "sender", "type": "address"}, {
            "internalType": "address",
            "name": "receiver",
            "type": "address"
        }, {"internalType": "uint256", "name": "id", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
        }],
        "name": "transferFrom",
        "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "newOwner", "type": "address"}],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "bytes", "name": "data", "type": "bytes"}],
        "name": "unlock",
        "outputs": [{"internalType": "bytes", "name": "result", "type": "bytes"}],
        "stateMutability": "nonpayable",
        "type": "function"
    }]
}